/**
 * The stock module's paths.
 *
 * Under `/admin` rather than at the root: this is operator tooling, not a fleet screen,
 * and grouping it with the other platform surfaces is what stops it appearing in the
 * mental model of a customer's nav even though the permission already hides it.
 */

export const STOCK_PATH = '/admin/stock'

export const STOCK_QUERY_KEYS = {
  status: 'status',
  purchaseBatch: 'batch',
  search: 'q',
} as const

/** A deep link into one status — what a tile links to. */
export function stockPath(status?: string): string {
  return status === undefined ? STOCK_PATH : `${STOCK_PATH}?${STOCK_QUERY_KEYS.status}=${status}`
}

/** Every unit from one shipment — the link a supplier conversation starts from. */
export function batchPath(batch: string): string {
  return `${STOCK_PATH}?${STOCK_QUERY_KEYS.purchaseBatch}=${encodeURIComponent(batch)}`
}
